import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

interface DetailRowProps {
  label: string;
  value: ReactNode;
}

function DetailRow({ label, value }: DetailRowProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        mb: 1,
      }}
    >
      <Typography variant="body1" component="span" sx={{ fontWeight: 'bold', minWidth: 140 }}>
        {label}:
      </Typography>

      <Typography variant="body1" component="span">
        {value || 'Not recorded'}
      </Typography>
    </Box>
  );
}

export default DetailRow;
